import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Skeleton } from '@mui/material';
export function TariffChooserPlaceholder() {
    return (_jsx(Box, { display: "flex", gap: 2, width: 400, children: [0, 1].map((key) => (_jsxs(Box, { width: "100%", children: [_jsx(Box, { mb: 1, children: _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 60 }) }), _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 200 })] }, key))) }));
}
